/**
 * Error codes matching the W3C FileError specification
 */
export var FileErrorCode;
(function (FileErrorCode) {
    FileErrorCode[FileErrorCode["NOT_FOUND_ERR"] = 1] = "NOT_FOUND_ERR";
    FileErrorCode[FileErrorCode["SECURITY_ERR"] = 2] = "SECURITY_ERR";
    FileErrorCode[FileErrorCode["ABORT_ERR"] = 3] = "ABORT_ERR";
    FileErrorCode[FileErrorCode["NOT_READABLE_ERR"] = 4] = "NOT_READABLE_ERR";
    FileErrorCode[FileErrorCode["ENCODING_ERR"] = 5] = "ENCODING_ERR";
    FileErrorCode[FileErrorCode["NO_MODIFICATION_ALLOWED_ERR"] = 6] = "NO_MODIFICATION_ALLOWED_ERR";
    FileErrorCode[FileErrorCode["INVALID_STATE_ERR"] = 7] = "INVALID_STATE_ERR";
    FileErrorCode[FileErrorCode["SYNTAX_ERR"] = 8] = "SYNTAX_ERR";
    FileErrorCode[FileErrorCode["INVALID_MODIFICATION_ERR"] = 9] = "INVALID_MODIFICATION_ERR";
    FileErrorCode[FileErrorCode["QUOTA_EXCEEDED_ERR"] = 10] = "QUOTA_EXCEEDED_ERR";
    FileErrorCode[FileErrorCode["TYPE_MISMATCH_ERR"] = 11] = "TYPE_MISMATCH_ERR";
    FileErrorCode[FileErrorCode["PATH_EXISTS_ERR"] = 12] = "PATH_EXISTS_ERR";
})(FileErrorCode || (FileErrorCode = {}));
/**
 * File system types
 */
export var FileSystemType;
(function (FileSystemType) {
    FileSystemType[FileSystemType["TEMPORARY"] = 0] = "TEMPORARY";
    FileSystemType[FileSystemType["PERSISTENT"] = 1] = "PERSISTENT";
})(FileSystemType || (FileSystemType = {}));
/**
 * Represents a file system directory location
 */
export var Directory;
(function (Directory) {
    /**
     * The Documents directory (iOS) / files directory (Android)
     * Persistent, user-visible, backed up
     */
    Directory["Documents"] = "DOCUMENTS";
    /**
     * The Data directory
     * Persistent private data storage
     */
    Directory["Data"] = "DATA";
    /**
     * The Library directory (iOS) / files directory (Android)
     * Persistent but not visible to user
     */
    Directory["Library"] = "LIBRARY";
    /**
     * The Cache directory
     * Temporary cache, may be cleared by OS
     */
    Directory["Cache"] = "CACHE";
    /**
     * External storage (Android only)
     * SD card or external storage root
     */
    Directory["External"] = "EXTERNAL";
    /**
     * External storage data directory (Android only)
     */
    Directory["ExternalStorage"] = "EXTERNAL_STORAGE";
    /**
     * Application bundle/assets directory (read-only)
     */
    Directory["Application"] = "APPLICATION";
})(Directory || (Directory = {}));
/**
 * Encoding types for reading files
 */
export var Encoding;
(function (Encoding) {
    Encoding["UTF8"] = "utf8";
    Encoding["ASCII"] = "ascii";
    Encoding["UTF16"] = "utf16";
})(Encoding || (Encoding = {}));
//# sourceMappingURL=definitions.js.map